export const environmentReports = {
  cashReceiptsDeposit: 'CashReceipts_Deposit',
  cashReceiptsLocationDeposit: 'CashReceipts_LocationDeposit',
  cashReceiptsLocationType: 'CashReceipts_LocationType',
  category: 'CategoryReport',
  categoryAnalysis: '',
  categoryTrend: 'CategoryTrendReport',
  clientAging: 'ClientAgingReport',
  csbcClientAging: 'ClientAgingReport_CSBC',
  clientAgingStark: 'ClientAgeReportStark',
  clientAgingByType: 'ClientAgeReportByType',
  clientCategoryTrend: 'ClientCategoryTrendReport',
  clientCompare: 'ClientCompareReport',
  categoryServices: 'CategoryServicesReport',
  clientPin: 'ClientPinReport',
  clientSummary: 'ClientSummaryReport',
  commisionReport: 'CommissionReportDet',
  companyTrend: 'CompanyTrendReport',
  fixedCharges: 'FixedChargesReport',
  forecast: 'ForecastReport',
  forecastv2: 'ForecastReportv2',
  glCategoryServices: 'GLCategoryServicesReport',
  glWhereUsed: 'GLWhereUsedReport',
  invoiceCategoryAnalysis: 'InvoiceCategoryAnalysisReport',
  invoiceDetailRegister: 'InvoiceDetailRegisterReport',
  invoiceFixedChargeComparison: 'InvoiceFixedChargeComparisonReport',
  invoiceFinalized: 'InvoiceFinalizedReport',
  invoicePrelimComparison: 'InvoicePrelimComparisonReport',
  invoicePrelimComparisonClient: 'InvoicePrelimComparisonClientReport',
  invoiceProcessing: 'InvoiceProcessing',
  monthlyPosting: 'MonthlyPostingReport',
  monthlyRecap: 'MonthlyRecapReport',
  occupancy: 'OccupancyReport',
  rateOverrides: 'RateOverridesReport',
  securityDeposit: 'SecurityDepositReport',
  taxAnalysis: 'TaxAnalysisReport',
  taxDetail:  'TaxDetailReport',
  taxTable: 'TaxTableReport',
  transactionControlAuditReport: 'TransactionControlAuditReport',
  transactionChangeReportAuditSum: 'TransactionChangeReportAuditSumm',
  unitTrend: 'UnitTrendReport',
  virtualSales: 'VirtualSalesReport'
};
